
function IntegrationsCardsCtrl(TranslationService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    this.$onInit = function () {
        this.size = 22;
    };

    this.repair = function (integrationID) {
        console.log('repair' + integrationID);
    };

    this.edit = function (integrationID) {
        console.log('edit ' + integrationID);
    };

    this.editModal = function (item) {
        console.log('editModal');
    };

}

IntegrationsCardsCtrl.$inject = ['TranslationService'];

seedWebApp.component('integrationsCards', {
    controller: IntegrationsCardsCtrl,
    bindings: {
        listItems: '<',
        filterString: '<'
    },
    templateUrl: './SPA/integrations/integrationsCards.html'
});